export default __webpack_public_path__ + "static/media/twokitty-lick.36e9fd03.jpeg";